var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99974 0.666748L0.301758 14.0001H15.6977L7.99974 0.666748ZM8.89307 6.42129L8.72687 9.25461H7.26947L7.10327 6.42129H8.89307ZM7.99814 11.7357C7.75101 11.7357 7.53901 11.6494 7.36214 11.4768C7.18741 11.3021 7.10114 11.0901 7.10327 10.8408C7.10114 10.5979 7.18741 10.3901 7.36214 10.2175C7.53901 10.045 7.75101 9.95868 7.99814 9.95868C8.23254 9.95868 8.43921 10.045 8.61821 10.2175C8.79927 10.3901 8.89094 10.5979 8.89307 10.8408C8.89094 11.007 8.84721 11.1583 8.76201 11.2946C8.67894 11.4289 8.57027 11.5365 8.43601 11.6174C8.30181 11.6963 8.15581 11.7357 7.99814 11.7357Z",
    fill: "#EC985B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautions);
export default __webpack_public_path__ + "static/media/cautions.b9cfe77e73d344e1abfff3262588b11a.svg";
export { ForwardRef as ReactComponent };